<template>
    <div class="popup">
        <div class="popup-content" :class="{ 'is-loading': isLoading }">
            <button class="popup-close" @click.prevent="handleClosePopup"></button>

            <div class="popup-scrollable">
                <h2>Object afronden</h2>

                <div class="alert alert-danger mb-5">
                    <strong>Let op:</strong> Alle geplande opnames worden hiermee afgerond.
                </div>

                <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" style="margin-top: 10px;">

                    <div class="alert alert-danger" v-if="error" v-text="error"></div>
                    <div class="alert alert-success" v-if="success" v-text="success"></div>

                    <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('reason') }">
                        <label class="form-label" for="description">Reden van afronding</label>
                        <textarea name="description" id="description" cols="30" rows="10" v-model="form.reason"></textarea>
                    </div>

                    <input type="submit" value="Object afronden" class="btn btn-primary mt-2">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
	import Form from '@/utilities/Form'
	import { UPDATE_SCHEDULE } from '@/store/modules/schedule'
	import { UPDATE_OBJECT } from '../../store/modules/objects'

	export default {
		components: {},

		props: ['object'],

		data () {
			return {
				error: null,
				success: null,
				isLoading: false,
				options: [],
				form: new Form({
					reason: null,
				}),
			}
		},

		methods: {
			handleClosePopup () {
				this.$emit('togglePopup')
			},

			onSubmit () {
				this.isLoading = true

				let scheduleUpdates = this.object.schedule.map((schedule) => {
					return this.$store.dispatch(UPDATE_SCHEDULE, {
						id: schedule.id,
						changes: {
							status: 3,
                            action: 'completed'
						},
					})
				})

				let updateObject = this.$store.dispatch(UPDATE_OBJECT, {
					projectID: this.object.project.id,
					id: this.object.id,
					changes: {
						description: this.object.description + '\n\n' + this.form.reason,
					},
				})

				Promise.all([scheduleUpdates, updateObject]).then(() => {
                    window.location.reload();
					this.isLoading = false
				})
			},
		},
	}
</script>